import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, ReadonlyHttpApiRepository } from '@softline/core';
import { SOFTLINE_API_ABC_ANALYSIS_CONFIGURATIONS } from '../abc-analysis.api';
import { AbcAnalysisConfigurationsResult } from '../types/abc-analysis-configuration';

@Injectable()
export class AbcAnalysisConfigurationsRepository extends ReadonlyHttpApiRepository<
  AbcAnalysisConfigurationsResult,
  undefined
> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_ABC_ANALYSIS_CONFIGURATIONS);
  }
}
